import { render, staticRenderFns } from "./import-monthly-allowance.vue?vue&type=template&id=499653e8&"
import script from "./import-monthly-allowance.vue?vue&type=script&lang=js&"
export * from "./import-monthly-allowance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports